<template>
  <div>
    <input :class="$style.input" v-bind:value="value" type="text" @input="updateField($event.target.value)">
  </div>
</template>

<script>
  export default {
    name: 'Input',
    props: ['value'],
    methods: {
      updateField (val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss" module>
  .input {
    display: block;
    width: 100%;
    padding: 0.7em;
    font-size: 1em;
    border: 1px solid #ddd;
    margin-bottom: 0.5em;
    border-radius: 3px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
    outline: none;

    &:focus {
      border-color: #2196f3;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/lib/Form/Input/index.vue